import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import {getRolesUserByToken, login, refreshTokenReservas} from './_requests'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {WithChildren} from '../../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'

let temporizador = setInterval(() => {})
let settm = setInterval(() => {})

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()

  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }
  //

  const logout = () => {
    localStorage.setItem('isLoggedIn', 'false')

    saveAuth(undefined)
    setCurrentUser(undefined)
    localStorage.removeItem('DJSRIEESMKD')

    const columnsToRemove = [
      'columnasCanalDist',
      'columnasCar',
      'columnasCarDetail',
      'columnasCatOrgVentas',
      'columnasCentros',
      'columnasClienteB2B',
      'columnasClienteB2C',
      'columnasClienteEmpresarial',
      'columnasClientes',
      'columnasContacto',
      'columnasContactoB2B',
      'columnasContactoB2BConsentimiento',
      'columnasContactoB2C',
      'columnasContactoB2CConsentimiento',
      'columnasContactoEmpresarial',
      'columnasContactoPersona',
      'columnasContactoPersonaConsentimiento',
      'columnasEmpleado',
      'columnasEmpleadoCtlg',
      'columnasEspecifTecnicas',
      'columnasEsqEstatus',
      'columnasEstatus',
      'columnasGrpVendedor',
      'columnasOfVentas',
      'columnasOrgVentas',
      'columnasReserva',
      'columnasSector',
      'columnasSociedad',
      'columnasSurvey',
      'columnasUsuario',
      'idCar',
      'idClienteEmpresarial',
      'idClientePersona',
      'idContacto',
      'idEsqEstatus',
      'idFAQ',
      'idGrpConsentimiento',
      'idOfVentas',
      'idOrgSaas',
      'idOrgVentas',
      'idSector',
      'idSociedad',
      'columnasCotizacion',
      'filtrosCotizacion',
      'dataLocalizacion',
      'columnasorgVxLocal',
      'idDocumento',
      'idPais',
      'idUsuario',
      'columnasApp_Ov_Usuario',
      'columnasRol_x_Usuario',
      'columnasCanalDistOrgCtlg',
      'columnasCtlgComponenteFront',
      'columnasGrpVendedorOrgCtlg',
      'columnasOfVentasOrgCtlg',
      'columnasOrgVentasCtlg',
      'columnasSurveyOrg',
      'columnasConsntante',
      'columnasConsentimientoCtlg',
      'columnasConsentimientoOrgVCtlg',
      'columnasGrpConsentimiento',
      'idFlag',
      'idConsentimiento',
      'columnasDocumento',
      'columnasInteraccionUsuario',
      'columnasVerificacion',
      'idAplicativoOV',
      'columnasCotizacionHeader',
      'idReservaHeader',
      'idCotizacionC',
      'idPedidoC',
      'idPedidoP',
      'filtrosUsuario',
    ]

    columnsToRemove.forEach((column) => {
      localStorage.removeItem(column)
    })
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({children}) => {
  const {auth, logout, setCurrentUser, saveAuth, currentUser} = useAuth()
  const didRequest = useRef(false)
  const navigate = useNavigate()
  const intl = useIntl()
  const [count, setCount] = useState(30)
  // const [count1, setCount1] = useState(30)
  const [status, setStatus] = useState('stop')
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application

  useEffect(() => {
    setCount(30)
    if (status == 'inicio') {
      temporizador = setInterval(() => {
        setCount((count) => count - 1)
        //  console.log(count);
      }, 1000)
    }
    return () => {
      clearInterval(temporizador)
    }
  }, [status])

  useEffect(() => {
    // console.log(tiempoexpira);
    // navigate('/modules')

    const requestUser = async (w_Token: string) => {
      try {
        if (!didRequest.current) {
          const {data} = await getRolesUserByToken(w_Token)
          console.log(data)
          if (data) {
            const extendedData: UserModel = {
              ...data,
              registro: {
                ...data.registro,
                IdOrgV: auth ? (auth.IdOrgV ? auth.IdOrgV : '') : '',
                DescripcionOrgV: auth ? (auth.DescripcionOrgV ? auth.DescripcionOrgV : '') : '',

                IdRol: auth ? (auth.IdRol ? auth.IdRol : '') : '',
                IdAplicativoxOV: auth ? (auth.IdAplicativoxOV ? auth.IdAplicativoxOV : 0) : 0,
                funcionalidad: auth ? (auth.funcionalidad ? auth.funcionalidad : []) : [],
                DescripcionRol: auth ? (auth.DescripcionRol ? auth.DescripcionRol : '') : '',
                IdOrgSaas: auth ? (auth.IdOrgSaas ? auth.IdOrgSaas : 0) : 0,
                DescripcionOrgSaas: auth
                  ? auth.DescripcionOrgSaas
                    ? auth.DescripcionOrgSaas
                    : ''
                  : '',
                IdIndustria: auth ? (auth.IdIndustria ? auth.IdIndustria : 0) : 0,
              },
            }

            setCurrentUser(extendedData)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (auth && auth.access_token) {
      const usuarioactual = authHelper.getAuth()
      requestUser(auth.access_token_ob)
      console.log(usuarioactual)

      const evaluarFechaToken = () => {
        let today = new Date()
        let now = today.toLocaleString('en-GB')
        let nueva2 = ''
        let nueva3 = ''
        const fechaHora = auth.expires_in.split(' ')
        const fecha = fechaHora[0].split('/').reverse().join('-')
        const hora = fechaHora[1]

        const nueva = new Date(`${fecha} ${hora}`)
        // console.log(nueva);
        nueva3 = nueva.toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })

        nueva.setSeconds(nueva.getSeconds() - 30)
        nueva2 = nueva.toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })

        let timeEndsincoma = nueva2.replace(',', '')

        let datesincoma = now.replace(',', '')
        let nueva3sincoma = nueva3.replace(',', '')

        // {REVISAR ÉSTA LÍNEA}
        const fechaHora1 = nueva3sincoma.split(' ')
        const fecha1 = fechaHora1[0].split('/').reverse().join('-')
        const hora1 = fechaHora1[1]

        const fecha_1 = new Date(`${fecha1} ${hora1}`)

        const fechaHora2 = datesincoma.split(' ')
        const fecha2 = fechaHora2[0].split('/').reverse().join('-')
        const hora2 = fechaHora2[1]

        const fecha_2 = new Date(`${fecha2} ${hora2}`)

        // console.log(fecha1,fecha2);
        // Restar las fechas y convertir el resultado a segundos
        const diffSegundos = (fecha_1.getTime() - fecha_2.getTime()) / 1000
        // console.log(diffSegundos);
        //nueva3sincoma es el tiempo de expiración
        //timeendsincoma es el tiempo de expiración 30 segundos antes
        //datesincoma es el tiempo de la maquina
        // console.log(datesincoma,timeEndsincoma,nueva3sincoma,diffSegundos);
        if (nueva3sincoma < datesincoma) {
          logout()
          clearInterval(intervalo)
        }

        if (timeEndsincoma == datesincoma || (diffSegundos > 0 && diffSegundos < 30)) {
          setStatus('inicio')

          Swal.fire({
            title: `Su sesión expirará en:`,
            // text: '¿Necesita mas tiempo para continuar?',
            html: `<b></b>
            <br/><br/>
            ¿Necesita mas tiempo para continuar?`,
            icon: 'warning',
            iconColor: 'red',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            allowOutsideClick: false,
            timer: (diffSegundos + 2) * 1000,
            didOpen: () => {
              let valor = diffSegundos
              const b = Swal.getHtmlContainer()?.querySelector('b')
              intervalo = setInterval(() => {
                if (b) {
                  if (valor < 0) {
                    setCount(30)
                    setStatus('stop')
                    logout()
                  } else {
                    b.textContent = `${valor}`
                    valor--
                  }
                }
                //  console.log(count);
              }, 1000)
            },
            willClose: () => {
              console.log('hola')
              clearInterval(intervalo)
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              const dominioActual = window.location.hostname.startsWith('www.')
                ? window.location.hostname.substring(4)
                : window.location.hostname

              if (!auth?.refresh_token_ob) {
                logout()
                return
              }

              const {data: auth1} = await refreshTokenReservas(auth.refresh_token_ob)
              saveAuth(auth1)

              if (auth1.msg_id === '0') {
                const {data: user} = await getRolesUserByToken(auth1.access_token_ob)
                if (user) {
                  const extraData = {
                    IdOrgV: auth?.IdOrgV ?? '',
                    DescripcionOrgV: auth?.DescripcionOrgV ?? '',
                    IdRol: auth?.IdRol ?? '',
                    IdAplicativoxOV: auth?.IdAplicativoxOV ?? 0,
                    funcionalidad: auth?.funcionalidad ?? [],
                    DescripcionRol: auth?.DescripcionRol ?? '',
                    IdOrgSaas: auth?.IdOrgSaas ?? 0,
                    DescripcionOrgSaas: auth?.DescripcionOrgSaas ?? '',
                    IdIndustria: auth?.IdIndustria ?? 0,
                  }

                  const extendedData: UserModel = {
                    ...user,
                    registro: {...user.registro, ...extraData},
                  }

                  setCurrentUser(extendedData)

                  const auxLocal = {
                    ...auth,
                    ...auth1,
                    ...extraData,
                  }

                  saveAuth(auxLocal)
                }

                Swal.fire({
                  title: 'Sesión renovada',
                  text: 'Sigue disfrutando de BackOffice Reservas',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                })

                setCount(30)
                setStatus('stop')
                if (settm) clearTimeout(settm)
                if (intervalo) clearInterval(intervalo)
              } else {
                logout()
                if (intervalo) clearInterval(intervalo)
              }
            } else {
              logout()
              clearInterval(intervalo)
            }
          })
          clearInterval(intervalo)
        }
      }
      // llama a la función evaluarVariable cada segundo
      let intervalo = setInterval(evaluarFechaToken, 1000)
      return () => {
        clearInterval(intervalo)
      }
    } else {
      setCount(30)
      setStatus('stop')
      logout()
      setShowSplashScreen(false)
    }

    // eslint-disable-next-line
  }, [auth])

  useEffect(() => {
    const handleStorageChange = () => {
      if (localStorage.getItem('isLoggedIn') === 'false') {
        logout()
        window.location.reload()
        // Cerrar sesión si detectamos que el usuario ha cerrado sesión en otra pestaña
      }
    }

    // Añadir el listener para el evento storage
    window.addEventListener('storage', handleStorageChange)

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [logout])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
